// Life's a Blur Shopify Theme JS

// Cart functionality
document.addEventListener('DOMContentLoaded', function() {
  // Update cart count
  const updateCartCount = () => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountEl = document.getElementById('cart-count');
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
        }
      });
  };

  // Initialize
  updateCartCount();

  // Listen for cart updates
  document.addEventListener('cart:updated', updateCartCount);

  // Mobile menu toggle
  const mobileMenuButton = document.getElementById('mobile-menu-button');
  const mobileMenuDropdown = document.getElementById('mobile-menu-dropdown');
  
  if (mobileMenuButton && mobileMenuDropdown) {
    mobileMenuButton.addEventListener('click', function() {
      mobileMenuDropdown.classList.toggle('active');
      
      // Toggle hamburger icon to X
      const svg = mobileMenuButton.querySelector('svg');
      if (mobileMenuDropdown.classList.contains('active')) {
        svg.innerHTML = '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>';
      } else {
        svg.innerHTML = '<line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line>';
      }
    });
    
    // Close menu when clicking on a link
    const mobileLinks = mobileMenuDropdown.querySelectorAll('.mobile-link');
    mobileLinks.forEach(link => {
      link.addEventListener('click', function() {
        mobileMenuDropdown.classList.remove('active');
        const svg = mobileMenuButton.querySelector('svg');
        svg.innerHTML = '<line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line>';
      });
    });
  }
  
  // Ensure hero video loops
  const heroVideo = document.getElementById('hero-video');
  if (heroVideo) {
    heroVideo.loop = true;
    heroVideo.muted = true;
    heroVideo.playsInline = true;
    
    // Fallback: if video ends, restart it
    heroVideo.addEventListener('ended', function() {
      this.currentTime = 0;
      this.play();
    });
    
    // Ensure video plays
    heroVideo.play().catch(function(error) {
      console.log('Video autoplay prevented:', error);
    });
  }

});
